import React, { useEffect, useState } from 'react';
import {
  Card, Form, Row, Col, Button,
} from 'react-bootstrap';
import { PlusLg } from 'react-bootstrap-icons';
import AsyncSelect from 'react-select/async';

import api from '../../../api';
import Required from '../../Required';

export default function Participants({ title, data, onChange, disabled }) {
  const addCard = () => {
    const lastId = data
      .filter((d) => d.id <= 0)
      .map((d) => d.id)
      .sort((a, b) => a - b)[0];
    const newId = lastId === undefined ? 0 : lastId - 1;
    const newItem = {
      id: newId, userId: undefined, user: {}, post: '',
    };
    onChange(data.concat([newItem]));
  };

  const deleteCard = (itemId) => {
    onChange(data.filter((d) => d.id !== itemId));
  };

  const mapOptionsToValues = (options) =>
    // value, label, isFixed, isDisabled
    options.map((option) => ({
      value: option.id,
      label: `${option.lastName || ''} ${option.firstName || ''} ${option.middleName || ''} (${option.post || 'должность не указана'})`,
      user: option,
    }));
  /** Для выбора у конкретного участника команды доступна только его роль (если уже выбрана) и роли, которые еще не заняты */
  const getAvailableUserRoles = (selectedRole, roles) => {
    const selectedRoles = data ? data.map((d) => d.role) : [];
    return roles.filter((r) => r === selectedRole || selectedRoles.indexOf(r) < 0);
  };

  const getOptions = async (inputValue, callback) => {
    if (!inputValue || inputValue.length < 3) {
      return callback([]);
    }
    const result = await api.get(`/users/employees?name=${inputValue.trim()}`);
    callback(mapOptionsToValues(result));
  };

  const onUserRoleChange = (itemId, value) => {
    const dataCopy = [...data];
    const changedItem = dataCopy.find((d) => d.id === itemId);
    changedItem.role = value;
    onChange(dataCopy);
  };

  const onUserItemChange = (user, selectedValue) => {
    const dataCopy = [...data];
    const changedItem = dataCopy.find((d) => d.id === user.id);
    changedItem.userId = selectedValue.value;
    changedItem.sAMAccountName = selectedValue.user.sAMAccountName;
    changedItem.post = selectedValue.user.post;
    changedItem.division = selectedValue.user.division;
    changedItem.displayName = `${selectedValue.user.lastName || ''} ${selectedValue.user.firstName || ''} ${selectedValue.user.middleName || ''}`;
    onChange(dataCopy);
  };

  const clearSelected = () => {
    const filteredArray = [{}];
    onChange(filteredArray);
  };

  return (
    <Card className="mb-4">
      <Card.Header className="p-4">
        <Card.Title style={{ marginBottom: 0 }}>Согласующие</Card.Title>
        <p className="text-muted" style={{ fontSize: '.875em', marginTop: '0.25rem' }}> В данном блоке вводить ФИО согласующих, карточку лиц, кроме руководителя проекта, куратора и заказчика.</p>
      </Card.Header>
      <Card.Body className="p-4">
        {data.map((item, index) => (
          <Row key={item.id}>
            <Form.Group as={Col}>
              <Card className="mb-4">
                <Card.Header style={cardHeaderStyling}>
                  <Button onClick={() => deleteCard(item.id)} variant="light" className="btn-close" size="sm" />
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Form.Group as={Col} md="6">
                      <Form.Label>ФИО </Form.Label>
                      <div>
                        <AsyncSelect
                          noOptionsMessage={() => 'Ничего не найдено'}
                          loadingMessage={() => 'Поиск...'}
                          placeholder="Введите ФИО"
                          value={!item.sAMAccountName ? null : { value: item.userId, label: item.displayName ? (`${item.displayName} (${item.post || 'должность не указана'})`) : '' }}
                          isClearable
                          isDisabled={disabled}
                          defaultOptions={[]}
                          loadOptions={getOptions}
                          onChange={(selectedValue, triggeredAction) => {
                            if (triggeredAction.action === 'clear') {
                              return clearSelected();
                            }
                            return onUserItemChange(item, selectedValue);
                          }}
                          components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                        />
                      </div>
                      <Form.Control.Feedback type="invalid">Выберите из списка</Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                </Card.Body>
              </Card>
            </Form.Group>
          </Row>
        ))}
        <Row>
          <Form.Group as={Col} md="12">
            <Button onClick={addCard} disabled={disabled} variant="outline-primary">
              <PlusLg className="me-1 mb-1" />
              Добавить
            </Button>
          </Form.Group>
        </Row>
      </Card.Body>
    </Card>
  );
}

const cardHeaderStyling = {
  display: 'flex', justifyContent: 'end', minHeight: 38,
};
